export default {"src":"/_next/static/media/icon_13.0ecb6167.svg","height":34,"width":34};